import clone from 'clone'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { UWPARAM_INIT_LOADING, POLTYPE_INIT_LOADING, POLTYPE_INIT_SUCCESS, POLTYPE_INIT_FAIL } from '@/store/types'
export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  policyMode: '',
  policyGeneralSettings: {
    init: 0,
    initErr: [],
    menu: {}
  },
  policyGeneral: {
    init: 0,
    menu: {},
    saving: false,
    saveError: {
      fieldMessages: [],
      messages: []
    }
  },
  policy: {
    init: 0,
    menu: {},
    saving: false,
    saveError: {
      fieldMessages: [],
      messages: []
    },
    // Policy Life Cycle state. Controls the steps within the Policy. Starts off as 1 but 0 is reserved for New Policy.
    policyLifeCycle: 1,
    promptWhenExit: true,
    policyInfo: {
      polNo: '--',
      renCnt: '00',
      endtCnt: '00',
      polTypeDesc: '--',
      branch: '--',
      fundDesc: '--',
      fromDate: '--',
      endDate: '--',
      uwYear: '--',
      insured: '--',
      // OS-411: Added 17-Sep-2020
      polStatDesc: '--',
      name: '--',
      ctyDesc: '--',
      fundDescription: '--',
      deptDesc: '--',
      busSrcDesc: '--',
      paytMethDesc: '--',
      finInstName: '--',
      armName: '--',
      createdName: '--',
      modifiedName: '--',
      cedAntName: '--',
      acctNoSfxDesc: '--',
      schemeDesc: '--'
    },
    polMaster: {
      polNo: undefined,
      renCnt: 0,
      endtCnt: 0,
      tranDate: undefined,
      endtDate: undefined,
      dri: undefined,
      appCoIns: undefined,
      polType: undefined
    },
    policyHeaderSettings: {
      init: 0,
      initErr: [],
      menu: {}
    }
  }
}

const getters = {

}

const mutations = {
  [UWPARAM_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [POLTYPE_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [POLTYPE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [POLTYPE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async polTypeManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.polTypeManagement
    commit(POLTYPE_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(POLTYPE_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(POLTYPE_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  // deep clone here, we need the initialState for resetting of state in ClaimNew
  state: clone(initialState),
  getters,
  mutations,
  actions
}
